import { type TimeReport } from "@entities";
import { type ColumnProps } from "@shared/frontend/hyper-table/types";
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import DoneOutlineIcon from '@mui/icons-material/DoneOutline';
import { Stack } from "@mui/material";

export const useTimeReportColumns = (): ColumnProps<TimeReport>[] => {
  return [
    { field: "association.user.name" },
    { field: "date" },
    { field: "hourCount" },
    { field: "organizationManager.name" },
    {
      field: "isConfirmed", cell: ({ row }) => {
        const isConfirmed = row.original.isConfirmed;
        return <Stack justifyContent="center" alignItems="center" width="100%"
        >{
            isConfirmed ? <DoneOutlineIcon style={{ color: "green", fontSize: "2rem" }} /> : <HighlightOffIcon style={{ color: "red", fontSize: "2rem" }} />
          }</Stack>;
      }
    },
    { field: "comments" }
  ];
};